import React, { useEffect, useState } from 'react'
import { Route, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { routes } from '@routes'
import { authService } from '@services/ServiceAuth'
import { ensureI18nNamespace, resolveNamespaceForPath } from '@store/i18n'
import { ensureSemanticUiStyles } from '@styles/ensureSemanticUiStyles'
import CanAccess from '@components/perms/CanAccess'
import SpinnerSegment from '@components/SpinnerSegment'

const PrivateRoute = ({ component: Component, modules, isFullPage, ...rest }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const [currentPath, setCurrentPath] = useState(window.location.pathname)

    if (currentPath !== window.location.pathname) {
        setCurrentPath(window.location.pathname)
    }

    useEffect(() => {
        async function checkUser() {
            const result = await authService.validateToken()

            if (result === false) {
                setIsLoading(false)
                history.push(routes.LOGIN + `?next=${currentPath}`)
                return
            }

            ensureSemanticUiStyles().catch(() => {})
            await ensureI18nNamespace(resolveNamespaceForPath(currentPath))
            setIsLoading(false)
        }

        checkUser()
    }, [history, currentPath])

    return (
        <>
            {!isLoading ? (
                <CanAccess allowedModules={modules} redirect>
                    <Route {...rest} render={(props) => <Component {...props} />} />
                </CanAccess>
            ) : (
                <SpinnerSegment loading={true} loadingMessage={t('loading')} fullHeight />
            )}
        </>
    )
}

export default PrivateRoute
